import { ReactElement } from "react";
import { AnimatedLogo } from "./AnimatedLogo";

export const LogoLoading = (): ReactElement => {
  return (
    <div className="flex absolute inset-0 justify-center items-center bg-black_00">
      <AnimatedLogo className="w-[100px] h-[100px] animate-spin" />
    </div>
  );
};
